export default __webpack_public_path__ + "locales/sl/SMTPSettings.json?hash=03789a4a71845193de13aece6812e412";